import { render, staticRenderFns } from "./ARTListAFA.vue?vue&type=template&id=1c5d7466&"
import script from "./ARTListAFA.vue?vue&type=script&lang=js&"
export * from "./ARTListAFA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports